// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"theme-switcher_themeSwitcher__ypLEi","control":"theme-switcher_control__W+CI-","inline":"theme-switcher_inline__r4Mpn"};